import { ScheduleProcessTypes } from '@app/eligibility/pages/administration/administration.component';
import { IntegrationTypeEnum } from './api-key.model';
import { Payer, PortalMfaType } from './payer.model';

export type ScheduleSetting = {
  scheduleDaysBeforeAppointment: number | null;
  autoSync: boolean;
  patientReVerification: boolean;
  patientReVerificationPeriod: number | null;
  patientReVerificationPeriodUnit: PatientReVerificationPeriodUnit;
  monthEligibilityReprocess?: boolean;
  dayEligibilityReprocess?: boolean;
  eligibilityProcessType?: ScheduleProcessTypes[];
  enableBillingProviderFallback?: boolean;
};

export enum PatientReVerificationPeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH'
}

export enum PayerCredentialStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Valid = 'Valid',
  Invalid = 'Invalid',
  Failed = 'Failed',
  PayerNotSupported = 'PayerNotSupported',
  MFACodeRequired = 'MFACodeRequired',
  Disconnected = 'Disconnected',
  MFASecurityAnswerRequired = 'MFASecurityAnswerRequired',
  Unknown = 'Unknown' // This state is not there in backend. But is added in frontend to handle exceptions
}
export type PayerCredentialErrorResponse = {
  code: string[];
  text?: string | null;
  message?: string | null;
};

export type PayerCredential = {
  id: number;
  username: string;
  password: string;
  authenticatorKey: string | null;
  status: PayerCredentialStatus;
  error?: PayerCredentialErrorResponse | null;
  website: string;
  loginUrl?: string | null;
  portalMfaType: PortalMfaType;
  otherPayers: { id: number; name: string; payerIdCode: string; portalMfaType: PortalMfaType }[];
  updatedAt: string;
  payer: Payer;
  mfaContact?: string | null;
  mfaType?: string | null;
  mfaQuestion?: string | null;
  externalConnectionId?: string[] | null;
  serviceSource?: number[] | null;
  expiresAt?: string;
  mfaService: DXCMFAServiceType;
  credMfaService: DXCMFAServiceType; // fix-it : ELIG-2427 spelling fix
  portalMfaService: DXCMFAServiceType[];
};

export interface IntegratorCredential {
  externalCredentialId: string;
  websiteUrl: string;
  payers: {
    id: number;
    name: string;
  }[];
  credentials: {
    id: number;
    payerPortalId: number;
    externalIdentifier: string;
    integratorType: IntegrationTypeEnum;
    createdAt: string;
    updatedAt: string;
  }[];
}

export enum DXCMFAServiceType {
  DXCEMail = 'DXCEmail',
  DXCSms = 'DXCSms'
}
export enum CredStatusCategoryEnum {
  Loading = 'Loading',
  UserInterventionRequired = 'UserInterventionRequired',
  Completed = 'Completed'
}

export type CredStateDetail = {
  displayText: string;
  title: string;
  statusType: 'success' | 'danger' | 'info' | 'warning';
  statusCategory: CredStatusCategoryEnum;
};

export enum GroupMFAType {
  Email = 'Email',
  SMS = 'SMS'
}
